import { endpoints } from 'api/endpoints'
import { GetArrayResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { RtmGroup, RtmGroupBase } from 'interfaces/api/rtmGroups.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<RtmGroup> => {
  const { data: response } = await axios.request<RtmGroup[]>({
    method: 'GET',
    url: endpoints.rtmGroups.getAll(),
  })
  return response
}

const create = async (data: RtmGroupBase): GetOneResponse<RtmGroup> => {
  const { data: response } = await axios.request<RtmGroup>({
    method: 'POST',
    url: endpoints.rtmGroups.create(),
    data,
  })
  return response
}

const update = async (id: number, data: RtmGroupBase): GetOneResponse<RtmGroup> => {
  const { data: response } = await axios.request<RtmGroup>({
    method: 'PATCH',
    url: endpoints.rtmGroups.update(id),
    data,
  })
  return response
}

const remove = (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.rtmGroups.remove(id),
  })

export const rtmGroupsApi = {
  create,
  getAll,
  update,
  remove,
}
